

<app-header></app-header>
<app-right-side></app-right-side>
<div class="container">
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12" style="top:0px">
            <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <h6 class="title" style="color: var(--text-color);"><i class="fad fa-icons"></i>&nbsp;Hobbies and Interests</h6>
                </div>
                <div class="ui-block-content">


                    <!-- Form Hobbies and Interests -->

                    <form [formGroup]="hobbiesForm" (ngSubmit)="setHobbies()">
                        <div class="row">

                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <strong class="title" style="color: var(--text-color);"> Hobbies:</strong>
                                <div class="form-group">
                                    <textarea class="form-control" placeholder="A hobby is an activity, interest, or pastime that is undertaken for pleasure or relaxation, done during one's own time." formControlName="hobby1" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                                </div>
                                <strong class="title" style="color: var(--text-color);"> Favorite Games:</strong>
                                <div class="form-group">
                                    <textarea class="form-control" placeholder="Swimming, Surfing, Scuba Diving, Anime, Photography, Tattoos, Street Art." formControlName="hobby2" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                                </div>

                                <!-- <button class="btn btn-secondary btn-lg full-width">Cancel</button> -->
                            </div>

                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <strong class="title" style="color: var(--text-color);"> Favorite TV Shows:</strong>
                                <div class="form-group">
                                    <textarea class="form-control" placeholder="The Crime of the Century, Egiptian Mythology 101, The Scarred Wizard, Lord of the Wings, Amongst Gods, The Oracle, A Tale of Air and Water." formControlName="hobby3" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                                </div>
                                <strong class="title" style="color: var(--text-color);"> Other Interests:</strong>
                                <div class="form-group">
                                    <textarea class="form-control" placeholder="Martin T. Georgeston, Jhonathan R. Token, Ivana Rowle, Alexandria Platt, Marcus Roth. " formControlName="hobby4" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                                </div>
                            </div>

                            <div *ngIf="errorMessage != ''" class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div *ngIf="errorMessage != ''" class="alert alert-danger" role="alert">
                                    {{errorMessage}}
                                </div>
                            </div>


                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <button [disabled]="loading" class="btn btn-primar1y btn-l1g full-w1idth" style="background-color: rgb(0, 0, 0); color: #fff; font-size: 15px;">
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                    Save 
                                </button>
                            </div>

                        </div>
                    </form>

                    <!-- ... end Form Hobbies and Interests -->

                </div>
            </div>
        </div>

        <div class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12 responsive-display-none" style="top:0px">
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">

                <!-- Your Profile  -->

                <div class="your-profile" >
                    <!-- <div class="ui-block-title ui-block-title-small">
                        <h6 class="title">Your PROFILE</h6>
                    </div> -->

                    <div id="accordion" role="tablist" aria-multiselectable="true" >
                        <div class="card" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <div class="card-header" role="tab" id="headingOne">
                                <h6>
                                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" dir="ltr">
                                        <i class="fad fa-user-cog"></i>&nbsp;Profile Settings
                                    </a>
                                </h6>
                            </div>

                            <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                                <ul class="your-profile-menu">
                                    <li>
                                        <a routerLink="/profile-setting" style="color: var(--text-color);"><i class="fad fa-id-card"></i>&nbsp;Personal Information</a>
                                    </li>

                                    <li>
                                        <a routerLink="/change-password" style="color: var(--text-color);"><i class="fad fa-lock"></i>&nbsp;Change Password</a>
                                    </li>
                                    <li>
                                        <a routerLink="/hobbies-and-intrests" style="color: var(--text-color);"><i class="fad fa-icons"></i>&nbsp;Hobbies and Interests</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ui-block-title">
                        <a routerLink="/friend-requests" class="h6 title" style="color: var(--text-color);"><i class="fad fa-user-clock"></i>&nbsp;Friend Requests</a>
                        <!-- <a routerLink="/friend-requests" class="items-round-little bg-blue">4</a> -->
                    </div>
                    <!-- <div class="ui-block-title ui-block-title-small">
						<h6 class="title">FAVOURITE PAGE</h6>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Create Fav Page</a>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Fav Page Settings</a>
					</div> -->
                </div>

                <!-- ... end Your Profile  -->

            </div>
        </div>
    </div>
</div>